/// <amd-module name="Test/TestPlansLibrary/TestCasesPivotFilter/Redux/TestCasesPivotFilterReducer" />
import produce from "immer";

import { TastCasesPivotFilterActions, TestCasesPivotFilterActionTypes } from "./TestCasesPivotFilterActions";
import { ITestCasesPivotFilterBarState } from "./TestCasesPivotFilterContracts";

export function TestCasesPivotFilterReducer(
    state: ITestCasesPivotFilterBarState,
    action: TastCasesPivotFilterActions
): ITestCasesPivotFilterBarState {
    state = state || ({} as ITestCasesPivotFilterBarState);

    return produce(state, (draftState: ITestCasesPivotFilterBarState) => {
        switch (action.type) {
            case TestCasesPivotFilterActionTypes.initializeFilterBarState:
                draftState.filterBarItems = action.payload.filterBarState.filterBarItems;
                draftState.assignedToSelection = action.payload.filterBarState.assignedToSelection;
                break;

            case TestCasesPivotFilterActionTypes.updateAssignedToIdentities:
                draftState.assignedToSelection = action.payload.newIdentities;
                break;

            default:
                break;
        }
    });
}
